<template>
    <div class="win">
        <div class="header">
            <div class="navItem">
                <i class="iconfont icon-lidianchi"></i>
                <div class="title" v-bind:style="{ letterSpacing: language === 'en' ? '0px':''}">{{ $t('ems.power.title') }}</div>
                <div class="desc">{{ $t('ems.power.desc') }}</div>
            </div>
            <div class="navRight">
                <div class="creatTime">{{ $t('ems.power.DataUpdateTime') }}:<span>{{ collectTime | nullFormat }}</span></div>
                <template v-if="systemSet.canResetPCS > 0">
                    <div class="btn" style="width: 110px"  @click="resetPCS"><i class="iconfont icon-shuaxin"></i>PCS复位</div>
<!--                    <div class="btn" style="width: 110px"  @click="fresh"><i class="iconfont icon-banbengengxin"></i>{{ $t('ems.power.UpdateTheData') }}</div>-->
                </template>
            </div>
        </div>
        <div class="content" v-loading="loading"  element-loading-text="Loading"  element-loading-spinner="el-icon-loading"  element-loading-background="rgba(42, 43, 44, 0.6)">
            <div class="pcs_tab">
                <template v-for="(item, index) in tabPage.pageList">
                    <div :class="{tab_item: true, active: item.id === activeTab}" :key="index" @click="loadTab(item)">
                        <div class="tab_item_top">{{item.tagName}}</div>
                        <div class="tab_item_bottom">{{item.SN}}</div>
                        <div class="arrow" v-if="item.id === activeTab"></div>
                    </div>
                </template>
                <div class="pageUp"  @click="next(-1)"><i class="iconfont icon-zuo" :style="{ color: tabPage.left ? 'rgb(68, 205, 234)' : 'rgb(166, 166, 166)'}" ></i></div>
                <div class="pageDown"  @click="next(1)"><i class="iconfont icon-you" :style="{ color: tabPage.right ? 'rgb(68, 205, 234)' : 'rgb(166, 166, 166)'}" ></i></div>
            </div>
            <div class="pcs_main">
                <cnPcsDetails ref="SXBLQ" :activeItem="{...activeItem}" v-if="activeItem.deviceType === 'SXBLQ'" ></cnPcsDetails>
                <pvPcsDetails ref="GFNBQ" :activeItem="{...activeItem}" v-else-if="activeItem.deviceType === 'GFNBQ'"></pvPcsDetails>
            </div>
        </div>
    </div>
</template>

<script>
    import { getPcs, chartPcs, pcsId, getCnPcsCuData, getCnPcsDuiData, getCnPcsStatus, getCnPcsEnvData, resetPCS } from "@/api/pcs";
    import { setStore, getStore } from "@/utils/store";
    import  cnPcsDetails from "@/view/Site/components/siteManage/pscDetails/cnPcsDetails";
    import  pvPcsDetails  from "@/view/Site/components/siteManage/pscDetails/pvPcsDetails";
    import i18n from "@/lang";
    import { mapGetters } from "vuex";
    import moment from "moment";
    import {themeOptions} from '@/theme';

    export default {
        name: "powerSys",
        components: { cnPcsDetails, pvPcsDetails  },
        data(){
            return {
                loading: false,
                groupNo: getStore({name: "siteNo"})||"",
                chartloading: false,
                pcsTotalList: [
                ],
                currentList: [],
                activeTab: "",
                activeItem: {},
                tabPage: {
                    totalList: [],
                    totalSize: 0,
                    pageList: [],
                    pageSize: 5,
                    totalPage: 0,
                    current: 1,
                    left: false,
                    right: false,
                },
                collectTime: '',

                powerChart: null,
                activeChart: 0,
            }
        },
        filters: {
            nullFormat(val){
                if(val === null || val === undefined){
                    return "--"
                }else {
                    return val
                }
            },
        },
        computed: {
            ...mapGetters(["language", "systemSet", "theme"]),
        },
        mounted(){
            this.initData();

            // this.tabListInit(this.pcsTotalList);
        },
        methods: {
            isShowInfo(){
                const userinfo = getStore({name: "userInfo"}) || { };
                return userinfo.detail && userinfo.detail.cellInfo === 1  && userinfo.detail.batteryAnalysis === 1 ;
            },

            resetPCS(){
                this.$confirm("是否将该PCS复位", {
                    confirmButtonText: i18n.t("ems.strategy.confirm"),
                    cancelButtonText: i18n.t("ems.strategy.cancel"),
                    type: "warning"
                }).then(() => {
                    this.loading = true;
                    const temp = this.tabPage.pageList.find(i => { return i.id == this.activeTab});
                    resetPCS(this.groupNo, temp.SN).then(() => {
                        this.loading = false;
                        this.$message.success("复位成功！");
                    }).catch(err => {
                        this.loading = false;
                        this.$message.error(err);
                    });
                }).then(() => {
                });
            },
            initData(){
                getPcs(this.groupNo).then(res => {
                    if(res && res.data && res.data.data){
                        this.pcsTotalList = (res.data.data.map(i =>{ return { id: i.id, name: i.deviceAlias, SN: i.deviceNo, tagName: i.deviceName, deviceType: i.deviceType }}));
                        if(this.pcsTotalList.length > 0){
                            this.tabListInit(this.pcsTotalList);
                        }
                    }
                }).catch(err =>{
                    this.$message.error(err);
                    console.error(err)
                });
            },

            tabListInit(data){
                this.tabPage.totalList = data;
                this.tabPage.current = 1;
                this.tabPage.totalSize = this.tabPage.totalList.length;
                this.tabPage.totalPage = Math.ceil(this.tabPage.totalSize / this.tabPage.pageSize);
                if(this.tabPage.totalPage > 1) {
                    this.tabPage.right = true;
                    this.tabPage.pageList = this.tabPage.totalList.slice((this.tabPage.current - 1) * this.tabPage.pageSize, this.tabPage.current * this.tabPage.pageSize);
                }else{
                    this.tabPage.right = false;
                    this.tabPage.pageList = this.tabPage.totalList;
                }
                this.tabPage.left = false;
                // this.activeTab = this.tabPage.pageList[0].id;
                if(this.tabPage.pageList.length > 0)this.loadTab(this.tabPage.pageList[0]);
                // console.log(this.tabPage)
            },
            next(step) {
                if (step === 1 && this.tabPage.right) {
                    this.tabPage.current = this.tabPage.current + 1;
                    this.tabPage.pageList = this.tabPage.totalList.slice((this.tabPage.current - 1) * this.tabPage.pageSize, this.tabPage.current * this.tabPage.pageSize);
                    this.tabPage.right = this.tabPage.current < this.tabPage.totalPage;
                    this.tabPage.left = true;
                }
                if (step === -1 && this.tabPage.left) {
                    this.tabPage.current = this.tabPage.current - 1;
                    this.tabPage.pageList = this.tabPage.totalList.slice((this.tabPage.current - 1) * this.tabPage.pageSize, this.tabPage.current * this.tabPage.pageSize);
                    this.tabPage.left = this.tabPage.current > 1;
                    this.tabPage.right = true;
                }
            },

            renderChart(type, isShowLoad = false){
                if (!this.$refs.powerChart) {
                    return;
                }
                this.powerChart = this.$echarts.init(this.$refs.powerChart);
                const temp = this.pcsTotalList.filter(i => { return i.id == this.activeTab });
                // console.log(this.pcsTotalList);
                this.activeChart = type;
                if(isShowLoad) { this.chartloading =true; }
                this.time = [moment().startOf('day'), moment()];
                chartPcs(temp[0].SN, type, this.time[0].valueOf(), this.time[1].valueOf()).then(res => {
                    this.chartloading =false;
                    const powerData = res.data.data['0'];
                    const SOCData = res.data.data['1'];
                    const color = themeOptions[this.theme].title1;
                    const option = {
                        tooltip: {
                            trigger: 'axis',
                        },
                        grid: {
                            top: '20%',
                            left: '5%',
                            right: '5%',
                            bottom: '3%',
                            containLabel: true
                        },
                        legend: {
                            data: [i18n.t("ems.power.TotalPower"), 'SOC'],
                            icon: 'rect',
                            itemWidth: 20,  // 设置宽度
                            itemHeight: 12, // 设置高度
                            itemGap: 20,
                            textStyle: {
                                color,
                                fontSize: 16,
                            },
                            top: '5%',
                        },
                        color: ['#2b8a5c', '#a14251', '#44cdea', '#eb9137'],
                        xAxis: [
                            {
                                type: 'category',
                                data: powerData.map(i => { return i.collectTime.substring(10, i.collectTime.length)}),
                                axisPointer: {
                                    type: 'shadow'
                                },
                                axisLine: {
                                    lineStyle: {
                                        color,
                                    }
                                },
                                axisTick: {
                                    alignWithLabel: true
                                },
                                splitLine: {
                                    show: true,
                                    lineStyle:
                                        {
                                            type: 'dashed',
                                            color: 'rgb(89, 89, 89)'
                                        }
                                },
                                boundaryGap: false,
                            }
                        ],
                        yAxis: [
                            {
                                name: i18n.t("ems.power.PowerkW"),
                                type: 'value',
                                // interval: (max/5).toFixed(1),
                                splitNumber: 6,
                                axisLabel: {
                                    formatter: '{value}',
                                    color,
                                },
                                axisLine: {
                                    lineStyle: {
                                        color,
                                    }
                                },
                                splitLine: {
                                    lineStyle:
                                        {
                                            type: 'dashed',
                                            color: 'rgb(89, 89, 89)'
                                            // dashOffset: 10
                                        }
                                }
                            },
                            {
                                name: "SOC(%)",
                                min: 0,
                                max: 100,
                                splitNumber: 6,
                                axisLabel: {
                                    formatter: '{value}',
                                    color,
                                },
                                axisLine: {
                                    lineStyle: {
                                        color,
                                    }
                                },
                                splitLine: {
                                    lineStyle:
                                        {
                                            type: 'dashed',
                                            color: 'rgb(89, 89, 89)'
                                            // dashOffset: 10
                                        },
                                    show: false,
                                }
                            }
                        ],
                        series: [
                            {
                                name: i18n.t("ems.power.TotalPower"),
                                type: 'line',
                                smooth: true,
                                data: powerData.map(i => +i.value),
                            },
                            {
                                name: 'SOC',
                                type: 'line',
                                smooth: true,
                                data: SOCData.map(i => +i.value),
                                yAxisIndex: 1,
                            },

                        ]
                    };
                    this.powerChart.setOption(option);
                }).catch(err => {
                    this.chartloading =false;
                    console.log(err);
                });
            },
            loadTab(item){
                if(item.id === this.activeTab) return;
                if(this.activeItem.deviceType === "SXBLQ"){
                    this.$refs.SXBLQ.unMqtt();
                }else if(this.activeItem.deviceType === "GFNBQ"){
                    this.$refs.GFNBQ.unMqtt();
                }
                this.activeTab = item.id;
                this.activeItem = {...item};

                setTimeout(() => {
                    if(this.activeItem.deviceType === "SXBLQ"){
                       // this.$refs.SXBLQ.loadTab();
                        if(this.$refs["SXBLQ"]) this.$refs["SXBLQ"].loadTab();
                    }else if(this.activeItem.deviceType === "GFNBQ"){
                       // this.$refs.GFNBQ.loadTab();
                        if(this.$refs["GFNBQ"]) this.$refs["GFNBQ"].loadTab();
                    }
                }, 200);

                return;
                // this.loading = true;
                if(this.activeTab !== ""){
                    window.mqttClient.unsubscribe(this.topic);
                    window.mqttClient.unsubscribe(this.topic1);
                    // window.mqttClient.unsubscribe(this.topic2);
                    window.mqttClient.unsubscribe(this.topic3);
                }
                this.mqttData = {};
                this.mqttData1 = [];
                this.mqttData2 = {};
                this.mqttData3 = {};
                this.httpInit();
                this.handleMqtt();
                setTimeout(() => {
                    if (this.isChartExtend == true) {
                        this.chartExtend();
                    } else {
                        this.renderChart(0, true);
                    }
                    this.fresh();
                }, 300)

            },
            showCollectTime(time){
                if(!time) return false;
                if (this.collectTime === "") {
                    this.collectTime = time
                }else{
                    if(moment(time).valueOf() > moment(this.collectTime).valueOf()){
                        this.collectTime = time
                    }
                }
            }
        },
    }
</script>

<style scoped lang="scss">
    @import "../../../../styles/site";
    @import "@/styles/common";
    .win{
        transition: all 0.5s linear;
        width: 100%;
        height: 100%;
        .header{
            height: 52px;
            background-color: var(--nav_inner);
            position: relative;
            .navItem{
                height: 100%;
                color: $font_bright_blue_title;
                display: flex;
                align-items: center;
                transition: all 0.3s linear;
                i{
                    font-size: 22px;
                    margin: 3px 20px 0;
                }
                .title{
                    letter-spacing: 3px;
                    font-size: 22px;
                }
                .desc{
                    margin-left: 24px;
                    font-size: 16px;
                    color: $_128_128_128;
                }
            }
            .navRight{
                position: absolute;
                height: 100%;
                right: 0;
                top: 0;
                display: flex;
                align-items: center;
                .creatTime{
                    font-size: 18px;
                    color: $_191_191_191;
                    margin-right: 40px;
                    width: 340px;
                    span{
                        padding-left: 20px;
                        color: $font_bright_blue_title;
                    }
                }
                .btn{
                    height: 30px;
                    width: 85px;
                    border: $font_bright_blue_title solid 2px;
                    margin-right: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 16px;
                    color: $font_bright_blue_title;
                    cursor: pointer;
                    -webkit-tap-highlight-color:rgba(0,0,0,0);
                    i{
                        margin-right: 5px;
                        font-size: 18px;
                    }
                }
            }
        }
        .content{
            height: calc(100% -  52px);
            padding: 0 30px;
            overflow: hidden;
            .pcs_tab{
                height: 80px;
                border-bottom: $font_bright_blue solid 1px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 160px;
                position: relative;
                .tab_item{
                    width: 170px;
                    height: 50px;
                    border: $_128_128_128 solid 1px;
                    color: $_191_191_191;
                    text-align: center;
                    cursor: pointer;
                    -webkit-tap-highlight-color:rgba(0,0,0,0);
                    position: relative;
                    transition: all 0.3s linear;
                    .tab_item_top{
                        height: 24px;
                        background-color: $_13_13_13;
                        line-height: 24px;
                        transition: all 0.3s linear;
                    }
                    .tab_item_bottom{
                        height: 26px;
                        line-height: 26px;
                        background-color: var(--tab_item_bottom);
                        transition: all 0.3s linear;
                    }
                    .arrow{
                        border-top-width: 0;
                        border-width: 6px;
                        width: 0;
                        height: 0;
                        border-color: transparent;
                        border-bottom-color: transparent;
                        border-style: solid;
                        position: absolute;
                        left: 80px;
                        bottom: -15px;
                    }
                }
                .active{
                    border: $font_bright_blue_title solid 1px;
                    .tab_item_bottom{
                        background-color: $font_bright_blue_title;
                        color: var(--app_bg);
                    }
                    .arrow{
                        border-bottom-color: $font_bright_blue_title;
                    }
                }
                .pageDown{
                    position: absolute;
                    right: 0;
                    top: 0;
                    width: 40px;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: $font_bright_blue;
                    cursor: pointer;
                    -webkit-tap-highlight-color:rgba(0,0,0,0);
                    i{
                        font-size: 34px;
                    }
                }
                .pageUp{
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 40px;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: $font_bright_blue;
                    cursor: pointer;
                    -webkit-tap-highlight-color:rgba(0,0,0,0);
                    i{
                        font-size: 34px;
                    }
                }
            }
            .pcs_main{
                height: calc(100% -  82px);
            }
            .boxBg{
                background-color: $_13_13_13;
                border: $_127_127_127 solid 1px;
            }

            .boxBg1{
                background-color: $_13_13_13;
                border: $_89_89_89 solid 1px;
            }
        }
    }
</style>